import { render, staticRenderFns } from "./courseB.vue?vue&type=template&id=2562c09c&scoped=true&"
import script from "./courseB.vue?vue&type=script&lang=js&"
export * from "./courseB.vue?vue&type=script&lang=js&"
import style0 from "./courseB.vue?vue&type=style&index=0&id=2562c09c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2562c09c",
  null
  
)

export default component.exports